<template>
  <div class="row">
    <div class="col-md-3">
      <div class="form-group">
        <datepicker
          :input-class="'form-control'"
          :format="'dd-MM-yyyy'"
          v-model="durDate"
          @selected="getDateData($event)"
        ></datepicker>
      </div>
    </div>
    <div class="col-md-3" v-if="pType!=='return-analysis' && pType !== 'p9_S' && pType !== 's1' && filterOptions.length>1">
      <div class="form-group" v-if="filterOptions.length>1">
        <select class="form-control" v-model="selField[0]" name="raw-data-columns">
          <option
            v-for="(d, index) in filterOptions"
            v-bind:key="d.id+index"
            :value="d.id"
            disabled="disabled"
          >{{d.value}}</option>
        </select>
        <!-- <input class="form-control" v-model="selField[0]"/> -->
      </div>
    </div>
    <div class="col-md-2" v-if="pType!=='return-analysis' && pType !== 'p9_S' && pType !== 's1' && filterOptions.length>1">
      <div class="form-group" v-if="filterOptions.length>1">
        <input class="form-control" v-model="min[0]" placeholder="Min">
      </div>
    </div>
    <div class="col-md-2" v-if="pType!=='return-analysis' && pType !== 'p9_S' && pType !== 's1' && filterOptions.length>1">
      <div class="form-group" v-if="filterOptions.length>1">
        <input class="form-control" v-model="max[0]" placeholder="Max">
      </div>
    </div>
    <div class="col-md-3" v-if="pType==='return-analysis' || pType === 'p9_S'">
      <div class="form-group">
        <select class="form-control" v-model="selField" name="raw-data-columns">
          <option
            v-for="(d, index) in filterOptions"
            v-bind:key="d.id+index"
            :value="d.id"
          >{{d.value}}</option>
        </select>
      </div>
    </div>
    <div class="col-md-2" v-if="pType==='return-analysis' || pType === 'p9_S'">
      <div class="form-group">
        <input class="form-control" v-model="min" placeholder="Min">
      </div>
    </div>
    <div class="col-md-2" v-if="pType==='return-analysis' || pType === 'p9_S'">
      <div class="form-group">
        <input class="form-control" v-model="max" placeholder="Max">
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group">
        <!-- <input type="text" v-model="searchParams.sectorname" class="form-control" name="sector" placeholder="Search by Sector"/> -->
        <select class="form-control" name="sector" v-model="sector">
          <option value>Select Sector</option>
          <option
            v-for="(sec, index) in sectorData"
            :value="sec.sect_name"
            v-bind:key="sec.sect_code+index"
            readonly
          >{{sec.sect_name}}</option>
        </select>
      </div>
    </div>
    <div class="col-md-3" v-if="pType!=='return-analysis' && pType !== 'p9_S' && pType !== 's1' && filterOptions.length>1">
      <div class="form-group" v-if="filterOptions.length>1">
        <select class="form-control" v-model="selField[1]" name="raw-data-columns" >
          <option
            v-for="(d, index) in filterOptions"
            v-bind:key="d.id+index"
            :value="d.id"
            disabled="disabled"
          >{{d.value}}</option>
        </select>
        <!-- <input class="form-control" v-model="selField[1]" /> -->
      </div>
    </div>
    <div class="col-md-2" v-if="pType!=='return-analysis' && pType !== 'p9_S' && pType !== 's1' && filterOptions.length>1">
      <div class="form-group" v-if="filterOptions.length>1">
        <input class="form-control" v-model="min[1]" placeholder="Min">
      </div>
    </div>
    <div class="col-md-2" v-if="pType!=='return-analysis' && pType !== 'p9_S' && pType !== 's1' && filterOptions.length>1">
      <div class="form-group" v-if="filterOptions.length>1">
        <input class="form-control" v-model="max[1]" placeholder="Max">
      </div>
    </div>
    <div class="col-md-2">
      <div class="form-group">
        <button @click="filterData" class="btn btn-sm btn-primary" type="button">
          <i class="fa fa-filter" title="Filter"></i>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import Datepicker from "vuejs-datepicker";
export default {
  components: { Datepicker },
  // props: ["minRange", "maxRange", "filterOptions", "ddate", "selFilter"],
  props: ["filterOptions", "sectorData", "pType"],
  data() {
    return {
      durDate: new Date().setDate(new Date().getDate() - 1),
      min: [],
      max: [],
      selField: [],
      sector: ""
    };
  },
  created() {
      if (this.pType !== "return-analysis" && this.pType !== 'p9_S' && this.pType !== "s1") {
        // this.selField[this.filterOptions[1].id] = this.filterOptions[1].id;
        // this.selField[this.filterOptions[2].id] = this.filterOptions[2].id;
        if (this.filterOptions.length > 0 &&  this.filterOptions.length > 1) {
          this.selField[0] = this.filterOptions[1].id;
          this.selField[1] = this.filterOptions[2].id;
          this.min[0] = this.min[1] = this.max[0] = this.max[1] = "";
        } else {
          this.selField[0] = this.selField[1] = "";
          this.min[0] = this.min[1] = this.max[0] = this.max[1] = "";
        }
      } else {
        this.min = this.max = this.selField = "";
      }
  },
  watch: {
    filterOptions: function(value) {
      // console.log("Ptype", this.pType, this.filterOptions.length);
      if (this.pType !== "return-analysis" && this.pType !== "p9_S" && this.pType !== "s1") {
        if (this.filterOptions.length > 0 && this.filterOptions.length > 1) {
          this.selField[0] = this.filterOptions[1].id;
          this.selField[1] = this.filterOptions[2].id;
          this.min[0] = this.min[1] = this.max[0] = this.max[1] = "";
        } else {
          this.selField[0] = this.selField[1] = "";
          this.min[0] = this.min[1] = this.max[0] = this.max[1] = "";
        }
      } else {
        this.min = this.max = this.selField = "";
      }
    },
    pType: function(value) {
      // if (this.pType !== value) {
        if (this.pType !== "return-analysis" && this.pType !== "p9_S" && this.pType !== "s1") {
          if (this.filterOptions.length > 0 && this.filterOptions.length > 1) {
            this.selField[0] = this.filterOptions[1].id;
            this.selField[1] = this.filterOptions[2].id;
            // this.min[0] = this.min[1] = this.max[0] = this.max[1] = "";
          } else {
            this.selField[0] = this.selField[1] = "";
            this.min[0] = this.min[1] = this.max[0] = this.max[1] = "";
          }
        } else {
          this.min = this.max = this.selField = "";
        }
      // }
    }
  },
  methods: {
    filterData() {
      console.log("Filter data", this.selField, this.min, this.max);
      this.$emit("filter", {
        durDate: this.durDate,
        min: this.min,
        max: this.max,
        selField: this.selField,
        sector: this.sector
      });
    },
    getSectorData() {
      let _this = this;
      http.get("getSectorList", {}, function(error, response) {
        // console.log("Sector Data", response);
        _this.sectorData = response;
      });
    },
    getDateData(e) {
      console.log("Date Selected", e);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Filters.vue